(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dmuly-bulk-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dmuly-bulk-preview')) {
  customElements.define('dmuly-bulk-preview', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.input = this.form?.querySelector('input[name="quantity"]');
      if (!this.input) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency', currency: this.dataset.currency || 'AUD', currencyDisplay: 'code'
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-quantity]');
        if (!button || this.input.disabled) return;
        this.input.value = button.dataset.quantity;
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.input.dispatchEvent(new FocusEvent('blur'));
        this.update();
      }, options);
      for (const name of ['input', 'change', 'quantity:update', 'click']) {
        this.form.addEventListener(name, () => requestAnimationFrame(() => this.update()), options);
      }
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      const quantity = Number(this.input.value);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      const percent = this.dataset.freshener === 'true' ? (quantity >= 5 ? 20 : 0) : Math.min(quantity - 1, 4) * 5;
      const subtotal = Number(this.dataset.price) * quantity;
      const saving = Math.floor(Number(this.dataset.price) * percent / 100) * quantity;
      const money = cents => this.money.format(cents / 100);
      const values = { quantity, percent, total: money(subtotal - saving), saving: money(saving) };
      const template = percent ? this.dataset.summary : this.dataset.single;
      this.querySelector('[role="status"]').textContent = template.replace(/\[([a-z]+)\]/g, (_, key) => values[key]);
      this.querySelectorAll('button[data-quantity]').forEach(button => {
        const count = Number(button.dataset.quantity);
        button.setAttribute('aria-pressed', String(count === quantity || (count === 5 && quantity >= 5)));
        button.disabled = this.input.disabled || (this.input.max !== '' && count > Number(this.input.max));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
